export const getQueryParam = (query: string) => {
	const search = window.location.search;
	const params = new URLSearchParams(search);
	const result = params.get(query);

	return result;
};
